module.exports = __webpack_public_path__ + "static/media/labtop_gif.e6340c6d.png";